import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { SEMINAR_INFORMATION_STATUSES, SEMINAR_INFORMATION_STATUS_PUBLIC, } from '../../../../../../define/consts/seminar/seminar_information';
import { propNumber, propStr, } from '../../../../../../helpers/custom-prop-types';
/**
 * セミナーの公開状態を表示する
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const ProfessionalMyPageTopMySeminarItemStatus = (props) => {
    const { className, status } = props;
    const { label } = useMemo(() => SEMINAR_INFORMATION_STATUSES.find((v) => v.value === status) || {}, [status]);
    return (_jsx("div", Object.assign({ className: clsx('professional_mypage_top_seminar_item_status', className, status === SEMINAR_INFORMATION_STATUS_PUBLIC.value ? 'public' : '') }, { children: _jsx("span", Object.assign({ className: 'status_text' }, { children: label })) })));
};
ProfessionalMyPageTopMySeminarItemStatus.propTypes = {
    className: propStr(),
    status: propNumber().isRequired,
};
ProfessionalMyPageTopMySeminarItemStatus.defaultProps = {
    className: '',
};
export default ProfessionalMyPageTopMySeminarItemStatus;
